import { FC } from 'react'

import { AttributeSection, SizeSelector } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { AccentColorContainer } from '../../../../../../containers/AccentColorContainer'
import { trackEvent } from '../../../../../../lib/analytics'
import { SectionWrapper } from '../styles'

import { IProps } from './IProps'
import { SizeChart } from './SizeChart'
import { SizeSelection } from './SizeSelection'

const category = 'product details'

export const SizesSection: FC<IProps> = ({
  minWidthStyle,
  hideTitle,
  isInvalid = false,
  isProductWaitlistable,
  onSizeSelect,
  selectedSize,
  sizeChart,
  sizes,
  disableMobileHorizontalSwipe,
  ...rest
}) => {
  const {
    sizesSection: { title, titleWhenInvalid },
  } = useTranslation()
  const { accentColor } = AccentColorContainer.useContainer()
  const sectionTitle = hideTitle ? undefined : isInvalid ? titleWhenInvalid : title
  const endAdornment = <SizeChart category={category} sizeChart={sizeChart} hideTitle={hideTitle} />

  const selection = (
    <SizeSelection
      selectedSize={selectedSize}
      isProductWaitlistable={isProductWaitlistable}
      category={category}
      hideTitle={hideTitle}
    />
  )

  return (
    <SectionWrapper {...rest} data-testid='size-picker' className='size-section'>
      <AttributeSection
        title={sectionTitle}
        selection={selection}
        isInvalid={isInvalid}
        id='size-section-title'
        endAdornment={endAdornment}
      >
        <SizeSelector
          accentColor={accentColor}
          minWidthStyle={minWidthStyle}
          sizes={sizes}
          disableMobileHorizontalSwipe={disableMobileHorizontalSwipe}
          selected={selectedSize}
          onSelectSize={onSizeSelect}
          {...trackEvent({
            category,
            action: 'select size',
            label: selectedSize?.shorthand ?? 'not selected',
            value: selectedSize?.shorthand ?? 'not selected',
          })}
        />
      </AttributeSection>
    </SectionWrapper>
  )
}
